<template>
  <div class="animated fadeIn" id="list-sirens">
    <transition name="fade">
      <b-card no-body>
        <div class="card-smallHeader card-header-action" v-b-toggle.collapse1>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <span class="when-opened">
              <i class="icon-arrow-down"></i>
            </span>
            <span class="when-closed">
              <i class="icon-arrow-up"></i>
            </span>
          </div>
        </div>
        <div class="py-2 px-3 mb-3">
          <div v-if="isLoadingLastDate">
            <LoadingField />
          </div>
          <div v-else-if="lastDateStatementWasLoaded">
            <span class="font-italic">Dernier chargement : </span>
            <i class="fa fa-calendar-check-o text-info ml-2 mr-2" style="font-size: 1.1rem;"></i>
            <span class="ml-2 font-weight-bold text-dark">{{ lastDateStatementWasLoaded }}</span>
          </div>
        </div>

        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="search">
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Décompte</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="numero_decompte"><strong>N° décompte</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input class="" type="number" id="numero_decompte" size="sm"
                                  v-model="numero_decompte"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="montant_decompte"><strong>Montant</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input class="" type="text" id="montant_decompte" size="sm"
                                  v-model="montant_decompte"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="type_decompte"><strong>Type</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select size="sm" id="type_decompte" v-model="type_decompte"
                                   :options="typesDecomptes"></b-form-select>
                  </b-col>
                </b-row>

                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="statut_decompte"><strong>Statut</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select size="sm" id="statut_decompte" v-model="statut_decompte"
                                   :options="statusDecomptes"></b-form-select>
                  </b-col>
                  <b-col sm="1">
                    <label for="date_debut_decompte"><strong>Paiement du</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_debut_decompte" size="sm"
                                  v-model="date_debut_decompte"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="date_fin_decompte"><strong>Paiement au</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_fin_decompte" size="sm"
                                  v-model="date_fin_decompte"></b-form-input>
                  </b-col>
                </b-row>

                <!-- début du champs de recherche du chargement -->
                <b-row class="mb-1 ml-1">
                  <b-col sm="4">
                  </b-col>
                  <b-col sm="1">
                    <label for="date_chargement_debut_decompte"><strong>Chargement du</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_chargement_debut_decompte" size="sm"
                                  v-model="date_chargement_debut_decompte"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="date_chargement_fin_decompte"><strong>Chargement au</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="date" id="date_chargement_fin_decompte" size="sm"
                                  v-model="date_chargement_fin_decompte"></b-form-input>
                  </b-col>
                </b-row>
                <!-- fin du champs de recherche du chargement -->
              </b-card>
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Salarié</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="nom_salarie"><strong>Nom salarié</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="nom_salarie" size="sm" v-model="nom_salarie"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="prenom_salarie"><strong>Prénom salarié</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="prenom_salarie" size="sm" v-model="prenom_salarie"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="nir_salarie"><strong>N°SS</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="nir_salarie" size="sm" v-model="nir_salarie"></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Etablissement / Contrat</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="siren"><strong>SIREN</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="siren" size="sm" v-model="siren"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="nic"><strong>NIC</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="nic" size="sm" v-model="nic"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="raison_sociale"><strong>Raison Sociale</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="raison_sociale" size="sm" v-model="raison_sociale"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="numero_contrat"><strong>Contrat</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="numero_contrat" size="sm" v-model="numero_contrat"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="famille_produit"><strong>Fam. produit</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select size="sm" id="famille_produit" v-model="famille_produit"
                                   :options="allFamillesProduits">
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-card>
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Identifiant CeV</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-1 ml-1">
                  <b-col sm="1">
                    <label for="nom_cev"><strong>Nom (Cev)</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="nom_cev" size="sm" v-model="nom_cev"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="prenom_cev"><strong>Prénom (Cev)</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="prenom_cev" size="sm" v-model="prenom_cev"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="email_cev"><strong>Email (Cev)</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input type="text" id="email_cev" size="sm" v-model="email_cev"></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="search" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
              <div class="mt-2">
                <span class="field-error">{{ errors.critere_recherche }}</span>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
    <b-card no-body>
      <b-card-header class="card-smallHeader">
        <i class="fa fa-list mr-2"></i>
        <span v-if="!isTable_2"><strong>Liste des décomptes IJ</strong></span>
        <span v-if="isTable_2"><strong>Liste des périodes</strong></span>
      </b-card-header>
      <b-card-body>
        <decomptes-table
          v-if="!isTable_2"
          :tableEntry="tableParam"
          ref="decomptes_table"
          @generate-pdf-from-decomptes="generatePDF"
          @generate-pdf-mutex-from-decomptes="generatePDFMutex"
          @update-status-from-decomptes="triggerUpdateStatus"
          @afficher-prestations-from-decomptes="afficherPrestationsFromDecomptes"
          @actions-from-decomptes="triggerActionFromDecomptes"
          @export-all-decomptes="triggerExportAllDecomptes">
        </decomptes-table>
        <periodes-table
          v-if="isTable_2"
          :tableEntry="tableParam"
          ref="periodes_table"
          @generate-pdf-from-periodes="generatePDF"
          @generate-pdf-mutex-from-periodes="generatePDFMutex"
          @update-status-from-periodes="triggerUpdateStatus"
          @actions-from-periodes="triggerActionFromPeriodes"
          @export-all-decomptes="triggerExportAllPeriodes"
          @go-back-main-search="search">
        </periodes-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '@/utils/auth';
  import {downloadFile, isEmpty, getFileIcon, getTimestamp} from "@/utils/fileHelper";
  import DecomptesTable from './DecomptesTable'
  import PeriodesTable from './PeriodesTable'
  import LoadingField from '@/components/LoadingField.vue';

  export default {
    components: {DecomptesTable, PeriodesTable, LoadingField},
    data() {
      return {
        lastDateStatementWasLoaded: '',
        isReady: false,
        showPeriodes: false,
        isTable_2: false,
        numero_decompte: '',
        montant_decompte: '',
        type_decompte: '',
        statut_decompte: '',
        date_debut_decompte: '',
        date_fin_decompte: '',
        date_chargement_debut_decompte: '',
        date_chargement_fin_decompte: '',
        nom_salarie: '',
        prenom_salarie: '',
        nir_salarie: '',
        siren: '',
        nic: '',
        raison_sociale: '',
        numero_contrat: '',
        famille_produit: '',
        nom_cev: '',
        prenom_cev: '',
        email_cev: '',
        allStatus: [],
        decompteIds: null,
        typesDecomptes: [
          {
            text: 'Tous',
            value: ''
          },
          {
            text: 'Décompte positif',
            value: '1',
          },
          {
            text: 'Décompte à zéro',
            value: '2',
          },
          {
            text: 'Décompte négatif',
            value: '3',
          },
        ],
        allFamillesProduits: [],
        statusDecomptes: [],
        errors: {
          critere_recherche: '',
          checkbox_1: '',
          checkbox_2: '',
        },
        isEmpty,
        noSearch: "noSearch",
        getTimestamp,
        isLoadingLastDate: false,
      };
    },
    mounted() {
      this.getFamillesProduits();
      this.getStatusDecomptes();

      this.isLoadingLastDate = true;
      this.fetchLastDateStatementWasLoaded()
        .then(date => {
          this.lastDateStatementWasLoaded = date;
        })
        .finally(() => {
          this.isLoadingLastDate = false;
        });

    },
    computed: {
      tableParam: {
        get() {
          let request = {};
          request.numero_decompte = this.numero_decompte;
          request.montant_decompte = this.montant_decompte;
          request.type_decompte = this.type_decompte;
          request.statut_decompte = this.statut_decompte;
          request.date_debut_decompte = this.date_debut_decompte;
          request.date_fin_decompte = this.date_fin_decompte;
          request.date_chargement_debut_decompte = this.date_chargement_debut_decompte;
          request.date_chargement_fin_decompte = this.date_chargement_fin_decompte;
          request.siren = this.siren.replace(/ /g, "")
          this.siren = request.siren
          request.nic = this.nic;
          request.raison_sociale = this.raison_sociale;
          request.numero_contrat = this.numero_contrat;
          request.famille_produit = this.famille_produit;
          request.nom_cev = this.nom_cev;
          request.prenom_cev = this.prenom_cev;
          request.email_cev = this.email_cev;
          request.nom_salarie = this.nom_salarie;
          request.prenom_salarie = this.prenom_salarie;
          request.nir_salarie = this.nir_salarie.replace(/ /g, "")
          this.nir_salarie = request.nir_salarie
          request.show_periodes = this.showPeriodes;
          request.decompte_ids = this.decompteIds;
          request.noSearch = this.noSearch;
          return request;
        }
      },
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common['Accept'] = 'application/json';
      this.$axios.defaults.headers.common['Provider'] = getProvider();

      if (this.$route.query.siren) {
        this.siren = this.$route.query.siren
      }

      if (this.$route.query.date_debut_decompte) {
        this.date_debut_decompte = this.$route.query.date_debut_decompte
      }

      if(this.$route.query.siren || this.$route.query.date_debut_decompte){
        this.search();
      }
    },
    methods: {
      async fetchLastDateStatementWasLoaded() {
        try {
          const response = await this.$axios.get('/espaceGestion/decomptesIJ/dernier-decompte-charge');
          return response.data.latestDate || '';
        } catch (e) {
          return '';
        }
      },
      search(){
        this.initFields();
        if (this.validateData()) {
          this.noSearch = 'search';
          this.whichTable();
          this.$store.commit("IS_LOADING", true);
          if (isEmpty(this.nom_salarie) && isEmpty(this.prenom_salarie) && isEmpty(this.nir_salarie)) {
            if (!isEmpty(this.$refs.decomptes_table)) {
              this.$refs.decomptes_table.$refs.table.refresh();
            }
          } else {
            if (!isEmpty(this.$refs.periodes_table)) {
              this.$refs.periodes_table.$refs.table.refresh();
            }
          }
        }
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.numero_decompte === ''
          && this.montant_decompte === ''
          && this.type_decompte === ''
          && this.statut_decompte === ''
          && this.date_debut_decompte === ''
          && this.date_fin_decompte === ''
          && this.date_chargement_debut_decompte === ''
          && this.date_chargement_fin_decompte === ''
          && this.nom_salarie === ''
          && this.prenom_salarie === ''
          && this.nir_salarie === ''
          && this.siren === ''
          && this.nic === ''
          && this.raison_sociale === ''
          && this.numero_contrat === ''
          && this.famille_produit === ''
          && this.nom_cev === ''
          && this.prenom_cev === ''
          && this.email_cev === '') {
          valid = false;
          this.errors.critere_recherche = 'Vous devez sélectionner au moins un critère de recherche';
        }
        return valid;
      },
      clearErrors() {
        this.errors.critere_recherche = '';
      },
      clearForm() {
        this.numero_decompte = '';
        this.montant_decompte = '';
        this.type_decompte = '';
        this.statut_decompte = '';
        this.date_debut_decompte = '';
        this.date_fin_decompte = '';
        this.date_chargement_debut_decompte = '';
        this.date_chargement_fin_decompte = '';
        this.nom_salarie = '';
        this.prenom_salarie = '';
        this.nir_salarie = '';
        this.siren = '';
        this.nic = '';
        this.raison_sociale = '';
        this.numero_contrat = '';
        this.famille_produit = '';
        this.nom_cev = '';
        this.prenom_cev = '';
        this.email_cev = '';
        this.decompteIds = null;
      },
      getFamillesProduits() {
        let self = this;

        this.$axios
          .get("/espaceGestion/dossier/getAllProduit")
          .then(response => {
            let nonDetermine = {};
            for (let famille of response.data.data) {
              if (famille.libelle !== 'Non déterminé') {
                this.allFamillesProduits.push({value: famille.id, text: famille.libelle});
              } else {
                nonDetermine = famille;
              }
            }
            this.allFamillesProduits.unshift({value: nonDetermine.id, text: nonDetermine.libelle});
            this.allFamillesProduits.unshift({value: 0, text: 'Tous'});
          })
          .catch(() => {
            self.handleError();
          });
      },
      getStatusDecomptes() {
        this.statusDecomptes = [];
        let self = this;
        this.$axios
          .get("/espaceGestion/decomptesIJ/getAllStatusDecomptes")
          .then(response => {
            const allStatus = response.data.status;
            this.allStatus = allStatus;
            this.statusDecomptes.push({value: '', text: 'Tous'});
            for (let key in allStatus) {
              this.statusDecomptes.push({value: allStatus[key].id, text: allStatus[key].libelle_front});
            }
          })
          .catch((error) => {
            self.handleError();
          });
      },
      handleError() {
        this.$store.commit("IS_LOADING", false);
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support Dosi.',
          showConfirmButton: false,
          timer: 4000
        });
      },
      whichTable() {
        if (isEmpty(this.nom_salarie) && isEmpty(this.prenom_salarie) && isEmpty(this.nir_salarie)) {
          this.isTable_2 = false;
        } else {
          this.isTable_2 = true;
        }

      },
      initFields() {
        this.showPeriodes = false;
        this.isReady = false;
        this.isTable_2 = false;
        this.decompteIds = null;
      },
      generatePDF(payload){
        this.downloadPDF(payload.numero_decompte, payload.decompte_id);
      },
      generatePDFMutex(payload){
        this.downloadPDFMutex(payload.numero_decompte, payload.decompte_id);
      },
      downloadPDF(numero_decompte, decompte_id) {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/decomptesIJ/generatePDF/' + decompte_id, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, 'decompte_' + numero_decompte, 'pdf');
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      downloadPDFMutex(numero_decompte, decompte_id) {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/decomptesIJ/generatePDFMutex/' + decompte_id, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, 'decompte_' + numero_decompte, 'pdf');
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      triggerActionFromDecomptes({action, rows}) {
        this.decompteIds = null;
        if (rows.length > 0) {
          if (action === 'export_csv') {
            this.downloadExcelDecompte({action: action, decomptes_ids: rows});
          }
          if (action === 'afficher_periodes') {
            this.decompteIds = rows;
            this.afficherPeriodes(rows);
          }
          if (action === 'neutralise' || action === 'en_attente' || action === 'a_verifier' || action === 'a_traiter') {
            this.updateStatus('decompte', action, rows);
          }
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !',
            text: 'Vous devez au moins cocher un décompte',
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      triggerActionFromPeriodes({action, rows}) {
        if (rows.length > 0) {
          if (action === 'export_csv') {
            this.downloadExcelPeriode({action: action, prestation_ids: rows});
          }
          if (action === 'archive' || action === 'a_traiter') {
            this.decompteIds = rows;
            this.updateStatus('prestation', action, rows);
          }
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !',
            text: 'Vous devez au moins cocher un décompte',
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      downloadExcelDecompte(dataPost) {
        let self = this;
        self.$store.commit('IS_LOADING', true);
        self.$axios.post('/espaceGestion/decomptesIJ/generateExcel', dataPost, {responseType: 'arraybuffer'})
          .then((response) => {
            self.$store.commit('IS_LOADING', false);
            downloadFile(response, 'decompte_' + Date.now(), 'csv');
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          })
      },
      downloadExcelPeriode(dataPost) {
        let self = this;
        self.$store.commit('IS_LOADING', true);
        self.$axios.post('/espaceGestion/decomptesIJ/genererExcelPrestation', dataPost, {responseType: 'arraybuffer'})
          .then((response) => {
            self.$store.commit('IS_LOADING', false);
            downloadFile(response, 'Periode-Extraction_' + Date.now(), 'csv');
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          })
      },
      afficherPrestationsFromDecomptes({decompte_id}) {
        this.afficherPeriodes(decompte_id);
      },
      afficherPeriodes(decompte_id) {
        this.showPeriodes = true;
        this.decompteIds = !Array.isArray(decompte_id) ? [decompte_id] : decompte_id;
        this.isTable_2 = true;
        this.isReady = true;
      },
      triggerUpdateStatus({type, statut_libelle_technique, ids}) {
        this.updateStatus(type, statut_libelle_technique, ids);
      },
      triggerExportAllDecomptes({search_data, data}) {
        // console.log('data',data)
        this.exportAllDecomptes(search_data, data);
      },
      triggerExportAllPeriodes({search_data, data}) {
        // console.log('data',data)
        this.exportAllPeriodes(search_data, data);
      },
      updateStatus(type, statut_libelle_technique, ids) {
        let self = this;
        let dataPost = {
          type: type,
          statut_libelle_technique: statut_libelle_technique,
          ids: !Array.isArray(ids) ? [ids] : ids,
        };
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment changer le statut de ce décompte ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Confirmer"
          })
          .then(result => {
            this.$store.commit('IS_LOADING', true);
            this.$axios.post('/espaceGestion/decomptesIJ/updateStatus', dataPost)
              .then((response) => {
                if (this.isTable_2 && isEmpty(this.nom_salarie) && isEmpty(this.prenom_salarie) && isEmpty(this.nir_salarie)) {
                  this.afficherPeriodes(this.decompteIds);
                } else {
                  this.search();
                }
              })
              .catch(function (error) {
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
              })
              .finally(() => self.$store.commit('IS_LOADING', false));
          });
      },
      exportAllDecomptes(searchData, data) {
        if (searchData.length !== 0) {
          if (isEmpty(data)) {
            this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Il n\'y a aucun décompte à exporter.',
                showConfirmButton: false,
                timer: 6000
              });
          } else {
            let self =this;
            let name = 'export_all_decomptes_' + this.getTimestamp();
            let ext = 'csv';
            searchData['forExport'] = true;
            this.$store.commit('IS_LOADING', true);
            this.$axios.post('/espaceGestion/decomptesIJ/exportAllDecomptes', searchData, {responseType: 'arraybuffer'})
              .then(response => {
                downloadFile(response, name, ext);
              })
              .catch(function (error) {
                let errorText = 'Une erreur est survenue pendant la génération de l\'export, si le problème persiste merci de faire un ticket au support DOSI';
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: errorText,
                  showConfirmButton: false,
                  timer: 5000
                });
              })
              .finally(() => self.$store.commit('IS_LOADING', false));
          }

        }
      },
      exportAllPeriodes(searchData, data) {
        if (searchData.length !== 0) {
          if (isEmpty(data)) {
            this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Il n\'y a aucune periode à exporter.',
                showConfirmButton: false,
                timer: 6000
              });
          } else {
            let self =this;
            let name = 'export_all_periodes_' + this.getTimestamp();
            let ext = 'csv';
            searchData['forExport'] = true;
            this.$store.commit('IS_LOADING', true);
            this.$axios.post('/espaceGestion/decomptesIJ/exportAllPeriodes', searchData, {responseType: 'arraybuffer'})
              .then(response => {
                downloadFile(response, name, ext);
              })
              .catch(function (error) {
                let errorText = 'Une erreur est survenue pendant la génération de l\'export, si le problème persiste merci de faire un ticket au support DOSI';
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: errorText,
                  showConfirmButton: false,
                  timer: 5000
                });
              })
              .finally(() => self.$store.commit('IS_LOADING', false));
          }

        }
      },
    }
  };
</script>
<style scoped>
  tr.VueTables__row td {
    line-height: 15px;
    padding: 0 0.75rem;
  }

  .formatted-box {
    white-space: nowrap !important;
    max-width: 100% !important;
  }
</style>
